import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  addressLine1: null,
  addressLine2: null,
  city: null,
  country: null,
  postalCode: null,
  state: null,
}

const billingAddressSlice = createSlice({
  name: 'billingAddress',
  initialState,
  reducers: {
    billingAddressUpdate: (state, { payload }) => ({
      ...state,
      ...payload,
    }),
  },
})

export const { billingAddressUpdate } = billingAddressSlice.actions

export const billingAddressSelector = state => state.billingAddress

export default billingAddressSlice.reducer
